<template>
  <!-- 外层容器，绝对定位在页面右侧，占满整个垂直可视区域 -->
  <div class="project-list-container">
    <div class="title">项目列表</div>
    <!-- 卡片容器，使用 el-card 组件，美化显示 -->
    <div class="project-list-card" shadow="hover">
      <!-- 筛选输入框 -->
      <el-input
        v-model="filterKeyword"
        placeholder="请输入关键字筛选项目..."
        clearable
        class="filter-input"
      >
        <!-- Element Plus 搜索图标作为前缀 -->
        <template #prefix>
          <Search />
        </template>
      </el-input>

      <!-- 列表滚动区域 -->
      <el-scrollbar class="list-scrollbar">
        <ul class="project-list">
          <el-card
            v-for="project in filteredProjects"
            :key="project.id"
            class="project-item"
            @click="toPrj(project.description, project.number)"
            shadow="hover"
          >
            {{ project.name }}
          </el-card>
        </ul>
      </el-scrollbar>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { openFile } from '@/service/PrjInfo'
import router from '@/router'

// 跳转到项目详情页面
const toPrj = async (description: string, number: string) => {
  console.log('prjInfo:', description)
  router.push({ path: '/detail', query: { filePath: description, number: number } })
//   await openFile(description)
}

// 定义项目类型
interface Project {
    id: number
    name: string
    description: string
    number: string
}

// 接收父组件传入的项目列表
const props = defineProps<{
  projects: Project[]
}>()

// 搜索关键字
const filterKeyword = ref('')

// 计算属性：根据关键字实时筛选
const filteredProjects = computed(() => {
  const keyword = filterKeyword.value.toLowerCase().trim()
  if (!keyword) return props.projects
  return props.projects.filter((project) => project.name.toLowerCase().includes(keyword))
})
</script>

<style scoped lang="scss">
.project-list-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 100vh;
  z-index: 999;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: #e6f7ff;
}

.title {
  color: #63b4f1;
  font-size: 18px;
  text-align: center;
  padding: 12px 0;
  margin: 0;
  box-sizing: border-box;
  border-bottom: #1ca6e1 solid 1px;
  border-radius: 4px 4px 0 0;
}

.project-list-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 16px;
  box-sizing: border-box;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

 
.filter-input {
  margin-bottom: 12px;
}

 
.list-scrollbar {
  flex: 1;
  overflow: auto;
}

 
.project-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* 列表项样式 */
.project-item {
  background-color: rgba(255, 255, 255, 0.6);
  color: #5ccce0;
  //   padding: 2px 2px;
  margin-bottom: 6px;
  border-radius: 6px;
  transition: background-color 0.2s;
  cursor: pointer;
  font-size: 16px;
}

/* 鼠标悬停时高亮 */
.project-item:hover {
  background-color: rgba(248, 244, 244, 0.8);
}
</style>
